
export const environment = {

       production: true,
       projectName:'Dcafe',
        apiURL: 'https://fasttvapi.dcafecms.com/', //dcafe development

  // apiURL: 'http://localhost:3200/', //dcafe development
  vendorManagementApiBaseUrl: 'https://fasttvapi.dcafecms.com',
       jsonBuilderCreateUrl: 'https://fasttvapi-json.dcafecms.com/jsonbuilder?id=51&type=create',
       metaUploadApiUrl: 'https://fasttv-autorecon.dcafecms.com/',
              // metaUploadApiUrl: 'http://localhost:3001/',

  metaUploadAuthUser: 'admin',
  metaUploadAuthPass: 'admin',

    apiURLEmbed: 'https://dcafeworld.admin.stage.dctinc.net/',

    faviconImg:'../assets/images/favicon.ico',
    dashbordMisc:'misc/data',
    dashbordAnalytics:'/analytics/subscription',
    dashbordvideoTop:'/order',
    dashbordplatform:'/analytics/videos/platform',
    dashbordcontent:'/upcomingasset',
    dashbordorders:'/ordercount',
    dashbordusers:'/customercount',

    logoPath:'assets/images/dcafeLogo.svg',
    adminApiUrl:'admin',
    authApiUrl:'/auth',
    loginUrl:'/login',
    forgotPasswordUrl:'/forgotpassword',
    updatePasswordUrl:'/updatepassword',
    configurationApiUrl:'/configuration',
    getProductConfigurationUrl:'/productconfiguration',
    updateProductConfigurationUrl:'/productconfiguration/update',
    insertProductConfigurationUrl:'/productconfiguration',

    getCouponUrl:'/coupon',
    updateCouponUrl:'/coupon/update',
    deleteCouponUrl:'/coupon/delete',
    insertCouponUrl:'/coupon',


    // getGeoZoneUrl:'/geozone',
    createFileUrl:'/file',
    uploadFileUrl:'/file/uploadimages',
    getProductTypeUrl:'/producttype',
    getGlobalProductTypeUrl:'/globalproducttype',
    updateProductTypeUrl:'/producttype/update',
    deleteProductTypeUrl:'/producttype/delete',
    insertProductTypeUrl:'/producttype',
    getPrimaryNavigationUrl:'/navigation',
    updatePrimaryNavigationUrl:'/navigation/update',
    deletePrimaryNavigationUrl:'/navigation/delete',
    insertPrimaryNavigationUrl:'/navigation',
    getGlobalPrimaryNavigationurl:'/globalprimarynavigation',
    getGlobalCertificationUrl:'/globalcertification',
    getGlobalGeozoneUrl:'/globalgeozone',
    globaltrailervideoUrl:'/globaltrailervideo',
    globalPageCategoryUrl:'/globalpagecategory',
    globalBlogUrl:'/globalblog',
    globalNewsUrl:'/globalnews',
    getVendorUrl:'/vendor',
    roleConfiguration:'/roleconfiguration',

    getAssetUrl:'/asset',
    updateAssetUrl:'/asset/update',
    deleteAssetUrl:'/asset/delete',
    deleteMultiple:'/asset/deleteMultiple',
    deleteMultipleAssetcategory:'/assetcategory/deleteMultiple',
    deleteMultipleAssetgroup:'/assetgroup/deleteMultiple',
    insertAssetUrl:'/asset',
    refreshUplynkUrl:'/channel/list',
    reconcillationUrl:'/reconcillation',
    deleteReconcillationUrl:'/reconcillation/delete',
    reconcillationVideoUrl:'/videos',

    getAssetGroupUrl:'/assetgroup',
    updateAssetGroupUrl:'/assetgroup/update',
    deleteAssetGroupUrl:'/assetgroup/delete',
    insertAssetGroupUrl:'/assetgroup',

    getAssetCategoryUrl:'/assetcategory',
    updateAssetCategoryUrl:'/assetcategory/update',
    deleteAssetCategoryUrl:'/assetcategory/delete',
    insertAssetCategoryUrl:'/assetcategory',


    getMrssQueueUrlList:'/mrss/queue/list',
    getMrssQueueUrl:'/mrss/queue',
    deleteMrssQueueUrl:'/mrss/queue/delete',
    insertMrssQueueUrl:'/mrss/queue/add',


    getClientUrl:'/clients',
    deleteClientUrl:'/clients/delete',
    insertClientUrl:'/clients',
    updateClientUrl:'/clients/update',



    getProfessionUrlList:'/profession/list',
    getProfessionUrl:'/profession',
    updateProfessionUrl:'/profession/update',
    deleteProfessionUrl:'/profession/delete',
    insertProfessionUrl:'/profession',


    getMrssPartnerUrl:'/mrss/partner/list',
    getMrssPartnerbyIdUrl:'/mrss/partner',
    updateMrssPartnerUrl:'/mrss/partner/edit',
    deleteMrssPartnerUrl:'/mrss/partner/delete',
    insertMrssPartnerUrl:'/mrss/partner/add',

    globaluplynkadserverUrl:'/globaluplynkadserver',
    globalliveeventUrl:'/globalliveevent',
    globalassetlibraryUrl:'/globalassetlibrary',
    globallibraryUrl:'/globallibrary',
    globalRoleUrl:'/globalrole',
    globallivevirtualchannelUrl:'/globallivevirtualchannel',
    globalCastUrl:'/globalcast',
    globalsponsorUrl:'/globalsponsor',
    getGlobalCharacterUrl:'/globalcharacter',
    getGlobalProfessionUrl:'/globalprofession',
    globalPageUrl:'/globalpage',


    getCastUrl:'/cast',
    updateCastUrl:'/cast/update',
    deleteCastUrl:'/cast/delete',
    insertCastUrl:'/cast',

    getCharacterUrl:'/character',
    updateCharacterUrl:'/character/update',
    deleteCharacterUrl:'/character/delete',
    insertCharacterUrl:'/character',


    getGeoZoneUrl:'/geozone',
    updateGeoZoneUrl:'/geozone/update',
    deleteGeoZoneUrl:'/geozone/delete',
    insertGeoZoneUrl:'/geozone',


    getCarouselUrl:'/carousel',
    updateCarouselUrl:'/carousel/update',
    deleteCarouselUrl:'/carousel/delete',
    insertCarouselUrl:'/carousel',


    getPageCategoryUrl:'/pagecategory',
    updatePageCategoryUrl:'/pagecategory/update',
    deletePageCategoryUrl:'/pagecategory/delete',
    insertPageCategoryUrl:'/pagecategory',

    updateMenuCategoryUrl:'/menucategory/update',
    insertMenuCategoryUrl:'/menucategory',
    getMenuCategoryUrl:'/menucategory',
    deleteMenuCategoryUrl:'/menucategory/delete',
    globalmenucategoryUrl:'/globalmenucategory',
    globalLanguageUrl:'/globallanguage',
    getAudioLanguageUrl:'/globalaudiolanguage',
    globalAssetGroupUrl:'/globalassetgroup',
    globalAssetCategoryUrl:'/globalassetcategory',

    getSubscriptionUrl:'/subscription',
    updateSubscriptionUrl:'/subscription/update',
    deleteSubscriptionUrl:'/subscription/delete',
    insertSubscriptionUrl:'/subscription',

    getRewardsUrl:'/coins/rewards',
    updateRewardUrl:'/coins/rewards',
    
    // Tier Management URLs
    getTierUrl:'/tier',
    insertTierUrl:'/tier',
    updateTierUrl:'/tier/update',
    deleteTierUrl:'/tier/delete',

    // Gamification URLs
    gamificationDashboardUrl:'/dashboard',
    userActionsUrl:'/user/actions',

    globalContinentListUrl: '/globalcontinent',
    globalCountryListUrl:'/globalcountry',
    globalCityListUrl:'/globalcity',
    globalStateListUrl:'/globalstate',
    globalDeviceTypeListUrl:'/globaldevicetype',
    globalLoginSourceListUrl:'/globalloginsource',
    globalReviewUrl:'/globalreview',
    globalclassificationUrl:'/globalclassification',

    globalGenreUrl:'/globalgenre',

    getGenreUrl:'/genre',
    updateGenreUrl:'/genre/update',
    deleteGenreUrl:'/genre/delete',
    insertGenreUrl:'/genre',

    insertUserUrl:'/user',
    getUserUrl:'/user',
    updateUserUrl:'/user/update',
    deleteUserUrl:'/user/delete',
    checkUrl:'/check',

    insertRoleUrl:'/role',
    getRoleUrl:'/role',
    updateRoleUrl:'/role/update',
    deleteRoleUrl:'/role/delete',

    insertRoleConfigurationUrl:'/roleconfiguration',
    getRoleConfigurationUrl:'/roleconfiguration',
    updateRoleConfigurationUrl:'/roleconfiguration/update',
    deleteRoleConfigurationUrl:'/roleconfiguration/delete',

    insertSponsorUrl:'/sponsor',
    getSponsorUrl:'/sponsor',
    updateSponsorUrl:'/sponsor/update',
    deleteSponsorUrl:'/sponsor/delete',

    insertReviewUrl:'/review',
    getReviewUrl:'/review',
    updateReviewUrl:'/review/update',
    deleteReviewUrl:'/review/delete',

    insertClassificationUrl:'/classification',
    getClassificationUrl:'/classification',
    updateClassificationUrl:'/classification/update',
    deleteClassificationUrl:'/classification/delete',

    insertUplynkadserverUrl: '/uplynkadserver',
    getUplynkadserverUrl: '/uplynkadserver',
    updateUplynkadserverUrl: '/uplynkadserver/update',
    deleteUplynkadserverUrl: '/uplynkadserver/delete',


    insertClientadserverUrl: '/clientadserver',
    getClientadserverUrl: '/clientadserver',
    updateClientadserverUrl: '/clientadserver/update',
    deleteClientadserverUrl: '/clientadserver/delete',


    insertFooterlinkUrl:'/footerlink',
    getFooterlinkUrl:'/footerlink',
    updateFooterlinkUrl:'/footerlink/update',
    deleteFooterlinkUrl:'/footerlink/delete',

    insertBlogsUrl:'/blog',
    getBlogsUrl:'/blog',
    updateBlogsUrl:'/blog/update',
    deleteBlogsUrl:'/blog/delete',

    insertCertificationUrl:'/certification',
    getCertificationUrl:'/certification',
    updateCertificationsUrl:'/certification/update',
    deleteCertificationUrl:'/certification/delete',
    getAllCertificationUrl:'/certification',

    insertBlogsCategoryUrl:'/blogcategory',
    getBlogsCategoryUrl:'/blogcategory',
    updateBlogsCategoryUrl:'/blogcategory/update',
    deleteBlogCategorysUrl:'/blogcategory/delete',

    insertNewsUrl:'/news',
    getNewsUrl:'/news',
    updateNewsUrl:'/news/update',
    deleteNewsUrl:'/news/delete',

    insertNewsCategoryUrl:'/newscategory',
    getNewsCategoryUrl:'/newscategory',
    updateNewsCategoryUrl:'/newscategory/update',
    deleteNewsCategoryUrl:'/newscategory/delete',

    bulkImportUrl:'/bulkupload/import',
    bulkExportUrl:'/bulkupload/export',

    deleteOrderUrl: '/order/delete',
    getOrderUrl: '/order',
    getSearchUrl: '/search',
    statusUpdateUrl :'/statusmanagement/update',
    getTracksUrl:'/track',


    /*region: 'us-east-1',
    identityPoolId: 'us-east-1:6eda459e-a901-490f-9dbd-718b00f1f72e',
    userPoolId: 'us-east-1_kg0C0IMlD',
    clientId: '5rlic1tomghnkvgm6h87tubu9m',
    bucketRegion: 'us-east-1',
    */
    region: 'us-east-2',
    identityPoolId: 'us-east-2:a8b553c5-8332-4b6e-a0c8-7e2f24203202',
    userPoolId: 'us-east-2_RBy14rj1C',
    //clientId: 't9drh85karb7mar7pp9ackqi6',
    clientId: '7lkn0ioek80sumuh01b9ftq1a1',
    rekognitionBucket: 'rekognition-pics',
    albumName: "usercontent",
    bucketRegion: 'us-east-2',
    ddbTableName: 'LoginTrail',
    cognito_idp_endpoint: '',
    cognito_identity_endpoint: '',
    sts_endpoint: '',
    dynamodb_endpoint: '',
    s3_endpoint: '',

    //below are

    configurationPageTitle:'Settings',
    conPageSubTitle:'Product Configuration',
    conPagePTSubTitle:'Product Type',

    navigationPageTitle:'Navigation Setup',
    nPageSubTitle:'Primary Navigation',
    nMenuCatPageSubTitle:'Secondary Navigation',

    assetPageTitle:'Asset Management',
    aGroupSubTitle:'Asset Group (Series Setup)',
    acategorySubTitle:'Asset Category (Seasons Setup)',
    aSubTitle:'Asset (Episodes, Movies, Songs…)',
    aReconSubTitle:'Asset Reconcillition',
    aTracksSubTitle:'Tracks',

    mrssIngestionPageTitle:'Mrss Partner',
    mPartnerSubTitle:'Mrss Partner',
    mQueueSubTitle:'Mrss Queue',

    dashbordTitle:'Unified Dashboard',
    // dashbordSubTitle:'Google Analytics',
    dashbordSubTitle: '',
    pagePageTitle:'Page Management',
    pCategoryPageTitle:'Page Setup (Content Rails)',
    pCarouselPageTitle:'Carousel Setup',

    masterPageTitle:'Master',
    mGenresPageTitle:'Genre Setup',
    mLangPageTitle:'Language',
    mGeoZoneSubTitle:'Geo Zone Mapping',
    mCandCSubTitle:'Add Cast & Crew',
    mSponsorSubTitle:'Sponsor',
    mReviewsSubTitle:'Reviews',
    mCustomSubPage:'Create Custom Asset Groups',
    mUserverSubPage:'Uplynk Ad Server',

    mFooterSubPage:'Add Footer link',
    mCharacterSubPage:'Character',
    mBCSubPage:'Blogs Category',
    mBlogSubPage:'Blog',
    mNCSubPage:'News Category',
    mNSubTitle:'News',
    mPSubTitle:'Profession',
    mCertification:'Set Certification Rules',

    monetizationPageTitle:'Monetization',
    moneSubscriptionSubPage:'Subscription',
    moneOrderSubPage:'Order Details',

    userPageTitle:'User Management',
    userSubTitle:'User List',
    uRoleSubTitle:'Role Setup',



    //aws configuration

    awsConfiguration: {

      'accessKeyId':'ZUPJELCAS8N30HX49OI0',
      'secretAccessKey':'Letb9izwR8vfZevjZmc4zghOqVdatRVoCnG63ZlU',
      'region':'us-west-1',
      'bucketName' : 'dcafeworld-asset.dcafeworld-asset'
    },

    auth0Config: {
      'enable':true,
      'domainName': 'dcafe-world.us.auth0.com',
      'clientId': '9t1VC5XghXipwOXYftp6RNy9fJ9S7WSW',
      'redirectUrl': 'http://localhost:4200/authorize',
      'responseType': 'token id_token'
    }


};
